export const showAdvanceAttributes = (signer) => {
  return signer.signature_mode === "advance"
}
